<template>
  <div class="footer_ball_users">
    <div class="team_info_vs">
      <div class="team_info left_team">
        <h3>{{ matchInfo.home }}</h3>
        <!-- 和产品沟通了，暂不显示 -->
        <!-- <p>何塞普-瓜迪奥拉：主教练</p>
        <p>10.4亿欧元：总身价</p>
        <p>70.26%：阵容胜率</p> -->
      </div>
      <div class="logo">
        <img v-if="matchInfo.home_logo.length > 0" :src="matchInfo.home_logo" />
        <img v-else src="./img/football.png" />
      </div>
      <div class="icon_compare">VS</div>
      <span class="logo">
        <img v-if="matchInfo.away_logo.length > 0" :src="matchInfo.away_logo" />
        <img v-else src="./img/football.png" />
      </span>
      <div class="team_info">
        <h3>{{ matchInfo.away }}</h3>
        <!-- 和产品沟通了，暂不显示 -->
        <!-- <p>主教练：波切蒂诺</p>
        <p>总身价：9.12亿欧元</p>
        <p>阵容胜率：68.26%</p> -->
      </div>
    </div>

    <div class="ball_team_map" v-loading="loading">
      <template v-if="homeUsers.first.length == 0 && homeUsers.substit.length == 0 && awayUsers.first.length == 0 && awayUsers.substit.length == 0 && loading == false">
        <panel-not-data message="当前赛事没有球队阵容数据..." img-name="queue" />
      </template>
      <template v-if="homeUsers.first.length > 0 || homeUsers.substit.length > 0 || awayUsers.first.length > 0 || awayUsers.substit.length > 0">
        <!--左侧队员-->
        <div class="team_red_list">
          <div class="title"><strong>首发阵容</strong><span class="line"></span></div>
          <ul>
            <li v-for="(person, index) of homeUsers.first" :key="index">
              <dl class="man_info">
                <dt>
                  <template v-if="person.incidents">
                    <img v-for="(num, index) in timeToArray(person.incidents[0].time)" :key="index" :src="require(`./img/numbers/black_${num}.png`)" />
                    <img v-if="person.incidents[0].time.length > 0" src="./img/numbers/black_minute.png" />
                    <!-- <img src="./img/match_status/15.png" /> -->
                  </template>
                  <strong>{{ person.name }}</strong>
                </dt>
                <dd v-if="['F', 'M', 'D', 'G'].includes(person.position)">{{ userDutys[person.position] }}</dd>
                <dd v-else>未知</dd>
              </dl>
              <div class="man_avatar">
                <img v-if="person.logo.length > 0" :src="person.logo" />
                <img v-else src="./img/avatar_default.png" />
              </div>
              <div class="man_code">{{ person.shirt_number }}</div>
            </li>
          </ul>

          <div class="title">
            <strong>替补阵容</strong>
            <span class="line"></span>
          </div>
          <ul>
            <li v-for="(person, index) of homeUsers.substit" :key="index">
              <dl class="man_info">
                <dt>
                  <!-- <img src="./img/match_status/15.png" /> -->
                  <strong>{{ person.name }}</strong>
                </dt>
                <dd v-if="['F', 'M', 'D', 'G'].includes(person.position)">{{ userDutys[person.position] }}</dd>
                <dd v-else>未知</dd>
              </dl>
              <div class="man_avatar">
                <img v-if="person.logo.length > 0" :src="person.logo" />
                <img v-else src="./img/avatar_default.png" />
              </div>
              <div class="man_code">{{ person.shirt_number }}</div>
            </li>
          </ul>
        </div>

        <!--球场阵容图-->
        <div class="team_map">
          <div class="team_red_score">
            <h4>{{ matchInfo.home }}</h4>
            <p>{{ teamScores.home }}</p>
          </div>
          <div class="team_blue_score">
            <h4>{{ matchInfo.away }}</h4>
            <p>{{ teamScores.away }}</p>
          </div>

          <template v-if="totalCoordinate.home == 0 && totalCoordinate.away == 0 && loading == false">
            <div class="not_ball_player">当前赛事没有球队阵容图数据...</div>
          </template>

          <!--红队球员及坐标-->
          <template v-if="totalCoordinate.home > 0">
            <dl class="man_clothes" v-for="(item, index1) of homeUsers.first" :key="`h${index1}`" v-show="item.x > 0 && item.y > 0" :style="getHomeCoordinate(item.x, item.y)">
              <dt class="red">
                <span class="code">
                  <img v-for="(num, index2) in timeToArray(item.shirt_number)" :key="`hnum${index2}`" :src="require(`./img/numbers/white_${num}.png`)" />
                </span>
                <div class="message" v-if="item.incidents">
                  <span class="minute">{{ item.incidents[0].time }}'</span>
                </div>
              </dt>
              <dd>{{ item.name }}</dd>
            </dl>
          </template>

          <!--蓝队球员及坐标-->
          <template v-if="totalCoordinate.away > 0">
            <dl class="man_clothes" v-for="(item, index1) of awayUsers.first" :key="`a${index1}`" v-show="item.x > 0 && item.y > 0" :style="getAwayCoordinate(item.x, item.y)">
              <dt class="blue">
                <span class="code">
                  <img v-for="(num, index2) in timeToArray(item.shirt_number)" :key="`anum${index2}`" :src="require(`./img/numbers/white_${num}.png`)" />
                </span>
                <div class="message" v-if="item.incidents">
                  <span class="minute">{{ item.incidents[0].time }}'</span>
                </div>
              </dt>
              <dd>{{ item.name }}</dd>
            </dl>
          </template>
        </div>

        <!--右侧队员-->
        <div class="team_blue_list">
          <div class="title"><span class="line"></span><strong>首发阵容</strong></div>
          <ul>
            <li v-for="(person, index) of awayUsers.first" :key="index">
              <div class="man_code">{{ person.shirt_number }}</div>
              <div class="man_avatar">
                <img v-if="person.logo.length > 0" :src="person.logo" />
                <img v-else src="./img/avatar_default.png" />
              </div>
              <dl class="man_info">
                <dt>
                  <strong>{{ person.name }}</strong>
                  <template v-if="person.incidents">
                    <!-- <img src="./img/match_status/15.png" /> -->
                    <img v-for="(num, index) in timeToArray(person.incidents[0].time)" :key="index" :src="require(`./img/numbers/black_${num}.png`)" />
                    <img v-if="person.incidents[0].time.length > 0" src="./img/numbers/black_minute.png" />
                  </template>
                </dt>
                <dd v-if="['F', 'M', 'D', 'G'].includes(person.position)">{{ userDutys[person.position] }}</dd>
                <dd v-else>未知</dd>
              </dl>
            </li>
          </ul>

          <div class="title"><span class="line"></span><strong>替补阵容</strong></div>
          <ul>
            <li v-for="(person, index) of awayUsers.substit" :key="index">
              <div class="man_code">{{ person.shirt_number }}</div>
              <div class="man_avatar">
                <img v-if="person.logo.length > 0" :src="person.logo" />
                <img v-else src="./img/avatar_default.png" />
              </div>
              <dl class="man_info">
                <dt>
                  <strong>{{ person.name }}</strong>
                  <!-- <img src="./img/match_status/15.png" /> -->
                </dt>
                <dd v-if="['F', 'M', 'D', 'G'].includes(person.position)">{{ userDutys[person.position] }}</dd>
                <dd v-else>未知</dd>
              </dl>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
//引入公用无数据组件
import PanelNotData from "@/components/match-recommend/not-data";
import pako from "pako";

export default {
  name: "FootballUsers",
  data() {
    return {
      loading: true,
      //接收到的内容，需要将三段内容拼接起来才能使用。必须是（1+2+3）的顺序
      getDatas: [],
      //球队比分
      teamScores: {
        home: "0",
        away: "0",
      },
      //有合理座标值的球员总数
      totalCoordinate: {
        home: 0,
        away: 0,
      },
      //球队成员清单：主队成员，球场阵容从first球员中来
      homeUsers: {
        first: [],
        substit: [],
      },
      //球队成员清单：客队成员，球场阵容从first球员中来
      awayUsers: {
        first: [],
        substit: [],
      },
      //队员身份
      userDutys: {
        F: "前锋",
        M: "中场",
        D: "后卫",
        G: "守门员",
      },
    };
  },
  components: {
    PanelNotData,
  },
  props: {
    matchInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    //增加强行关闭动画的定时器
    setTimeout(() => {
      this.loading = false;
    }, 20000);
  },
  methods: {
    /**
     * 第一次ready触发的事件的回调方法
     * @param {string} ret_data 触发modified事件后返回的数据
     */
    onTimModified(ret_data) {
    

      //{"lineup":"","type":""}
      console.log("lineup data:", ret_data);
      if (ret_data.length > 10) {
        let data = JSON.parse(ret_data);
        const gzipStr = data.lineup;
      
      // 将gzip字符串转换为Uint8Array类型的数据
      const gzipData = new Uint8Array(atob(gzipStr).split('').map(char => char.charCodeAt(0)));
      console.log (gzipData);
      // 解压gzip数据
      const uncompressedData = pako.inflate(gzipData, { to: 'string' });

      // 输出解压后的数据
      console.log(uncompressedData);
            let team_str = uncompressedData;
            if (team_str.indexOf("line_up") == -1) {
              return false;
            }
            let team_users = JSON.parse(team_str).line_up;
            // console.log("team_users:", team_users);
            this.teamScores = {
              home: team_users.home_formation,
              away: team_users.away_formation,
            };
            //循环处理一遍，构造主队的首发和替补人员
            let home_first = [];
            let home_substit = [];
            //统计有合理座标值的球员总数
            let total_coordinate = {
              home: 0,
              away: 0,
            };
            if ( team_users.home ){
            team_users.home.forEach((item) => {
              if (item.first == 1) {
                home_first.push(item);
                if (item.x > 0 && item.y > 0) {
                  total_coordinate.home++;
                }
              } else {
                home_substit.push(item);
              }
            });
          }
            this.totalCoordinate = total_coordinate;
            this.homeUsers = {
              first: home_first,
              substit: home_substit,
            };
            //循环处理一遍，构造客队的首发和替补人员
            let away_first = [];
            let away_substit = [];
            if ( team_users.home ){
            team_users.away.forEach((item) => {
              if (item.first == 1) {
                away_first.push(item);
                if (item.x > 0 && item.y > 0) {
                  total_coordinate.away++;
                }
              } else {
                away_substit.push(item);
              }
            });
          }
            this.awayUsers = {
              first: away_first,
              substit: away_substit,
            };

            //清空初始化时接收到的数据，用于下次接收时复用
            this.getDatas = [];
         
        }
    
      this.loading = false;
    },

    /**
     * 将时间转换为数组
     * @param {int} num 数值
     */
    timeToArray(num) {
      if (num || false) {
        return num.toString().split("");
      } else {
        return [0];
      }
    },

    /**
     * 将主队球员的坐标转换成rem单位
     * @param {int} x X轴座标
     * @param {int} y Y轴座标
     */
    getHomeCoordinate(x, y) {
      let x_rem = (x / 100) * 3.2;
      let y_rem = (y / 100) * 3;
      return "left: " + x_rem + "rem;top: " + y_rem + "rem";
    },

    /**
     * 将客队球员的坐标转换成rem单位
     * @param {int} x X轴座标
     * @param {int} y Y轴座标
     */
    getAwayCoordinate(x, y) {
      //X坐标发过来的球员在我们这个布局图里面，默认是左右反过来的
      let x_rem = (1 - x / 100) * 3.2;
      let y_rem = (y / 100) * 2.8;
      return "left: " + x_rem + "rem;bottom: " + y_rem + "rem";
    },
  },
};
</script>

<style lang="scss" scoped>
//[足球-球队阵容]对应的内容块部分
.footer_ball_users {
  clear: both;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0.2rem 0.25rem;

  .team_info_vs {
    display: flex;
    justify-content: center;
    align-items: center;
    clear: both;
    width: 100%;
    overflow: hidden;

    .team_info {
      width: 100%;
      height: 100%;
      overflow: hidden;

      h3,
      p {
        display: block;
        clear: both;
        width: 100%;
        line-height: 0.2rem;
        overflow: hidden;
        padding: 0px 0.15rem;
        font-size: 0.16rem;
        color: #333;
      }

      p {
        font-size: 0.14rem;
        color: #666;
      }
    }

    .left_team {
      text-align: right;
    }

    .logo {
      flex-shrink: 0;
      display: block;
      width: 64px;
      height: 64px;
      overflow: hidden;
      box-sizing: border-box;
      border-radius: 50px;
      border: 1px solid #dcdcdc;
      padding: 5px;

      img {
        display: block;
        height: 100%;
        margin: 0 auto;
      }
    }

    .icon_compare {
      flex-shrink: 0;
      width: 3.75rem;
      height: 100%;
      overflow: hidden;
      font-size: 0.4rem;
      color: #333;
      text-align: center;
    }
  }

  .ball_team_map {
    display: flex;
    justify-content: space-between;
    clear: both;
    width: 100%;
    min-height: 350px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0.2rem 0px;

    //足球场阵容图
    .team_map {
      flex-shrink: 0;
      width: 3.75rem;
      height: 6.5rem;
      overflow: hidden;
      background: url(./img/bg_start_lineup.png) no-repeat top center;
      background-size: 100%;
      box-sizing: border-box;
      padding: 0.12rem;
      position: relative;

      .not_ball_player {
        clear: both;
        width: 2.5rem;
        height: 0.4rem;
        line-height: 0.4rem;
        overflow: hidden;
        background-color: rgba(255, 255, 255, 0.8);
        box-sizing: border-box;
        border-radius: 0.1rem;
        padding: 0px 10px;
        text-align: center;
        font-size: 0.14rem;
        color: #666;
        margin: auto auto;
        position: absolute;
        z-index: 5;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
      }

      .team_red_score,
      .team_blue_score {
        float: left;
        min-width: 0.85rem;
        height: 0.45rem;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0.05rem 0.065rem;
        position: absolute;
        left: 0.12rem;

        h4,
        p {
          clear: both;
          width: 100%;
          height: 0.18rem;
          line-height: 0.18rem;
          overflow: hidden;
          font-size: 0.12rem;
          color: #fff;
        }

        p {
          font-family: "Arial";
        }
      }

      .team_red_score {
        top: 0.12rem;
      }

      .team_blue_score {
        bottom: 0.12rem;
      }

      //单个球员块
      .man_clothes {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 0.5rem;
        height: 0.5rem;
        position: absolute;
        z-index: 5;

        dt {
          display: flex;
          flex-direction: column;
          clear: both;
          width: 100%;
          height: 0.32rem;
          background-repeat: no-repeat;
          background-size: auto 100%;
          background-position: top center;
          position: relative;

          //球员编号
          .code {
            display: flex;
            justify-content: center;
            align-items: center;
            clear: both;
            width: 100%;
            height: 100%;
            overflow: hidden;
            box-sizing: border-box;
            padding-top: 0.1rem;
            text-align: center;

            img {
              display: inline-block;
              height: 0.1rem;
              margin: 0px 1px;
            }
          }

          //赛场实况信息
          .message {
            display: block;
            clear: both;
            width: auto;
            height: 0.18rem;
            overflow: hidden;
            background: rgba(246, 246, 246, 0.8);
            box-sizing: border-box;
            border-radius: 2px;
            padding: 2px 3px;
            white-space: nowrap;
            position: absolute;
            z-index: 3;
            left: 0.25rem;
            top: -0.08rem;

            img {
              display: inline-block;
              height: 100%;
              margin: 0px 1px;
              vertical-align: middle;
            }

            .minute {
              display: inline-block;
              width: auto;
              height: 100%;
              margin: 0px 1px;
              vertical-align: middle;
              font-size: 0.12rem;
              font-family: "Arial";
              color: #333;
            }
          }
        }

        dt.blue {
          background-image: url(./img/clothes_blue.png);
        }

        dt.red {
          background-image: url(./img/clothes_red.png);
        }

        dd {
          clear: both;
          width: 0.8rem;
          height: 0.18rem;
          line-height: 0.18rem;
          overflow: hidden;
          white-space: nowrap;
          font-size: 0.12rem;
          text-align: center;
          color: #fff;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
        }
      }
    }

    //左右侧球员列表
    .team_red_list,
    .team_blue_list {
      clear: both;
      width: 100%;
      overflow: hidden;

      //标题部分
      .title {
        width: 100%;
        height: 0.36rem;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0px 12px;
        background-color: #f6f6f6;
        font-size: 0.14rem;
        font-weight: bold;
        color: #333;

        strong {
          display: inline-block;
          width: auto;
          height: 100%;
          line-height: 0.36rem;
          overflow: hidden;
          box-sizing: border-box;
          padding: 0px 5px;
          vertical-align: middle;
        }

        .line {
          display: inline-block;
          width: 3px;
          height: 0.12rem;
          overflow: hidden;
          background-color: #02a8a2;
          border-radius: 5px;
          vertical-align: middle;
        }
      }

      //球员列表
      ul {
        clear: both;
        width: 100%;
        overflow: hidden;

        li {
          display: flex;
          justify-content: space-between;
          clear: both;
          width: 100%;
          height: 0.5rem;
          overflow: hidden;
          box-sizing: border-box;
          padding: 5px 12px;
          border-bottom: 1px solid #e5e5e5;

          .man_info {
            width: 100%;
            height: 100%;
            overflow: hidden;
            box-sizing: border-box;
            padding: 0px 5px;
            font-size: 0.12rem;

            dt,
            dd {
              width: 100%;
              height: 0.2rem;
              line-height: 0.2rem;
              overflow: hidden;
              color: #999;
            }

            dt {
              color: #333;

              strong {
                font-weight: 400;
              }

              img {
                display: inline-block;
                height: 0.1rem;
                margin: 0px 1px;
              }
            }
          }

          .man_avatar {
            flex-shrink: 0;
            width: 0.4rem;
            height: 100%;
            overflow: hidden;

            img {
              display: block;
              height: 100%;
              margin: 0 auto;
            }
          }

          .man_code {
            flex-shrink: 0;
            width: 0.3rem;
            height: 100%;
            line-height: 0.4rem;
            overflow: hidden;
            font-size: 0.16rem;
            color: #333;
          }
        }
      }
    }

    .team_red_list {
      text-align: right;
    }
  }
}
</style>